export const normalizeBookingStatus = (status: string): string => {
  // Convert any status format to the standard format (with underscore)
  return status.replace(/-/g, '_');
};

export const validStatuses = [
  "concept",
  "submitted",
  "approved",
  "waiting_for_goods",
  "goods_received_origin",
  "in_transit",
  "customs_pending_clearance",
  "custom_clearance",
  "customs_cleared",
  "fyco",
  "out_for_delivery",
  "delivery_planned",
  "delivered",
  "added_to_stock",
  "rejected",
  "cancelled",
  "archived"
] as const;

export type BookingStatus = typeof validStatuses[number];

export const statusColors: Record<BookingStatus, string> = {
  concept: "#faad14", // Yellow - draft
  submitted: "#1890ff", // Blue - in process
  approved: "#52c41a", // Green - approved
  rejected: "#f5222d", // Red - rejected
  waiting_for_goods: "#36cfc9", // Cyan - waiting
  goods_received_origin: "#722ed1", // Purple - goods received
  customs_pending_clearance: "#722ed1", // Purple - customs pending
  custom_clearance: "#fa8c16", // Orange - customs clearance in progress
  customs_cleared: "#52c41a", // Green - customs cleared
  fyco: "#1890ff", // Blue - fyco
  out_for_delivery: "#13c2c2", // Cyan - delivery
  delivery_planned: "#40a9ff", // Light blue - delivery planned
  delivered: "#389e0d", // Green - delivered
  added_to_stock: "#73d13d", // Light green - added to stock
  in_transit: "#096dd9", // Blue - transit
  cancelled: "#ff4d4f", // Red - cancelled
  archived: "#8c8c8c", // Grey - archived
};

export const statusSteps: Record<BookingStatus, number> = {
  concept: 0,
  submitted: 1,
  approved: 2,
  waiting_for_goods: 3,
  goods_received_origin: 4,
  in_transit: 5,
  customs_pending_clearance: 6,
  custom_clearance: 6.5,
  customs_cleared: 7,
  fyco: 8,
  out_for_delivery: 9,
  delivery_planned: 9.5,
  delivered: 10,
  added_to_stock: 11,
  rejected: -1,
  cancelled: -1,
  archived: -1,
}; 